module.exports = __webpack_public_path__ + "img/intro_1.c85005dd.jpg";